
import { defineComponent } from "vue";
import RoomHeader from "./room-header.vue";
import RoomControls from "./room-controls.vue";

export default defineComponent({
  name: "room",
  components: {
    RoomHeader,
    RoomControls
  },
  props: {
    name: String,
    time: Number
  }
});
